import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NSAutocompleteModule, NSErrorModule, NSSkeletonModule } from '@norfolk-southern/accessns-components';

import { UTOriginBatchWeighComponent } from '@ruby/modules/unit-train/submodules/ut-origin-batch-weigh/components/ut-origin-batch-weigh.component';
import { UTOriginBatchWeighContainer } from '@ruby/modules/unit-train/submodules/ut-origin-batch-weigh/containers/ut-origin-batch-weigh.container';
import { UTOriginBatchWeighRoutingModule } from '@ruby/modules/unit-train/submodules/ut-origin-batch-weigh/ut-origin-batch-weigh-routing.module';
import { DirectivesModule } from '@ruby/shared/directives/directives.module';

@NgModule({
  declarations: [
    UTOriginBatchWeighComponent,
    UTOriginBatchWeighContainer
  ],
  imports: [
    CommonModule,
    UTOriginBatchWeighRoutingModule,
    NSAutocompleteModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    DirectivesModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatToolbarModule,
    MatDividerModule,
    NSSkeletonModule,
    NSErrorModule
  ],
  exports: [
    UTOriginBatchWeighContainer
  ]
})
export class UTOriginBatchWeighModule {}
